module.exports = __webpack_public_path__ + "media/images/share_twitter-de9ff1d8bea2c860cef6b4ff6a73a1e1.svg";